//Module Keys
let locales = {};

//Merge Views
import main from 'Modules/simProviders/views/main/lan/en';
import createEditSimProvider from 'Modules/simProviders/views/.components/createEditSimProvider/lan/en';
import deleteSimProvider from 'Modules/simProviders/views/.components/deleteSimProvider/lan/en';

locales = { ...locales, ...main, ...createEditSimProvider, ...deleteSimProvider };

export default locales;